/*
 * @Author: shannyHuang
 * @Date: 2022-03-14 20:20:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-29 14:39:26
 * @FilePath: /wemeet-web-activity/src/utils/concat-meeting-util.ts
 */
import getWeMeet from '@utils/async-module/get-we-meet-sdk';
import { message } from '@tencent/tea-component';
import { navigateToLaunchIfNeed } from '@utils/login-util';
import type { NextRouter } from 'next/router';
import { isMeetingApp, isMobile } from './ua/is-mobile';
const LOG_TAG = 'concat-meeting-util';
let baseMeetingUrl = '';
// const baseMeetingUrl = window.location.origin;
/** pc跳转链接 */
export const pcUrl = {
  createWebinar: `${baseMeetingUrl}/user-center/webinar/schedule`, // 新建webinar会议
  createMetting: `${baseMeetingUrl}/user-center/user-meeting-list/schedule`, // 新建云会议
  webinarDetail: `${baseMeetingUrl}/user-center/webinar/detail`, // webinar详情
  meetingDetail: `${baseMeetingUrl}/user-center/user-meeting-list/detailed-meeting-info`, // 云会议详情
  webinarEdit: `${baseMeetingUrl}/user-center/webinar/update`, // 编辑webinar
  meetingEdit: `${baseMeetingUrl}/user-center/editorial-meeting`, // 编辑云会议
};
/** 移动端链接或scheme */
export const weMeet = {
  createWebinar: `${baseMeetingUrl}/v2/webinar-schedule`,
  createMetting: 'wemeet://page/premeeting/schedule',
  meetingDetail: 'wemeet://page/premeeting/meetinginfo',
  extralLink: 'wemeet://page/external_link',
  webViewLink: 'wemeet://page/webview',
};

const PcNavSchemeType = {
  /**
   * 非导航窗口，就是普通窗口
   */
  NONE: 'navgitaion_none',

  /**
   * 加入会议导航窗口
   */
  JOIN: 'navigation_join',
  /**
   * 预定会议导航窗口
   */
  SCHEDULE: 'navigation_schedule',
};

const DISABLED_TICKET_CODE = -160000;

export const openCreatePcMeetingPage = (type = 1) => {
  const url = `${type === 1 ? pcUrl.createWebinar : pcUrl.createMetting}?from=webinar_event`;
  window.nextAegis?.infoAll(`openCreatePcMeetingPage url :${url}`, LOG_TAG);
  window.open(url, '_blank');
};
export const openPcMeetingDetailPage = (id = '') => {
  const url = `${pcUrl.webinarDetail}/${id}?from=webinar_event`;
  window.nextAegis?.infoAll(`openPcMeetingDetailPage url :${url}`, LOG_TAG);
  window.open(url, '_blank');
};
export const openPcMeetingEditPage = (id = '') => {
  const url = `${pcUrl.webinarEdit}/${id}?from=webinar_event`;
  window.nextAegis?.infoAll(`openPcMeetingEditPage url :${url}`, LOG_TAG);
  window.open(url, '_blank');
};
export const openPcLobbyPage = (eventId: string, entry?: string) => {
  const url = `${window.location.origin}/events/lobby/${eventId}${entry ? entry : ''}`;
  if (isMeetingApp() && isMobile()) {
    window.location.href = url;
    return;
  }
  window.open(url, '_blank');
};
/** 移动端打开 */
export const openCreateH5MeetingPage = async (type = 1, router: NextRouter) => {
  if (weMeet.createWebinar.indexOf('https') === -1 || weMeet.createWebinar.indexOf('http') === -1) {
    baseMeetingUrl = window?.location?.origin;
    weMeet.createWebinar = baseMeetingUrl + weMeet.createWebinar;
  }
  const url = type === 1 ? `${weMeet.createWebinar}?mfrom=webinar_event` : weMeet.createMetting;
  window.nextAegis?.infoAll(`openPcMeetingEditPage url :${url}`, LOG_TAG);
  LaunchWemeetAppMethod(url, {}, false, router);
};

export const openH5MeetingDetailPage = async (id = '', router: NextRouter) => {
  window.nextAegis?.infoAll(
    `openH5MeetingDetailPage click id:${id} ，router：${JSON.stringify(router)}`,
    LOG_TAG,
  );
  LaunchWemeetAppMethod(
    weMeet.meetingDetail,
    {
      meeting_id: id,
    },
    PcNavSchemeType.SCHEDULE,
    router,
  );
};

/**
 * 判断是否小窗口显示
 * @param {*} urlValue
 * @returns
 */
export const isSmallWindow = (urlValue: string) => {
  const searchOpMsg = urlValue.indexOf('opmsg-center') !== -1;
  const searchOpTask = urlValue.indexOf('optask-center') !== -1;
  const searchNote = urlValue.indexOf('meeting-idea') !== -1;
  if (searchOpMsg || searchOpTask || searchNote) {
    return true;
  }
  return false;
};
/**
 * 拉起app
 * @param url
 * @param routeParams
 * @param pcNavScheme
 */
export const LaunchWemeetAppMethod = async (
  url: string,
  routeParams: any = {},
  pcNavScheme: any = PcNavSchemeType.NONE,
  router?: NextRouter,
) => {
  window.nextAegis?.infoAll(
    `【LaunchWemeetAppMethod】click url:${url},routeParams:${routeParams},pcNavScheme:${pcNavScheme},router:${router}`,
    LOG_TAG,
  );
  const { app, ui } = await getWeMeet();
  const iswemeet = app.isTMWebview();
  const support = (await app.compare('2.1.0')) > -1;
  window.nextAegis?.infoAll(
    `【LaunchWemeetAppMethod】iswemeet:${iswemeet},support:${support},url:${url}`,
    LOG_TAG,
  );
  if (iswemeet) {
    if (!support) {
      message.error({ content: `客户端版本低，请先升级版本再尝试(${DISABLED_TICKET_CODE - 2})` });
      return;
    }
    let obj = {
      params: { url, supportGoBack: true },
      schema: weMeet.webViewLink,
      pcNavScheme: undefined,
    };

    if (url && url.indexOf('wemeet://') > -1) {
      obj = {
        params: {
          ...routeParams,
          mfron: 'activity',
        },
        schema: url,
        pcNavScheme,
      };
    }
    ui.openNewPage(obj).catch((error) => {
      window?.nextAegis?.infoAll(`【wemeet open page】 error: ${error}`);
    });
    return;
  }
  if (router) {
    navigateToLaunchIfNeed(router);
    return;
  }
  location.href = url;
  // let link = url;
  // if (link && link.indexOf('wemeet://') > -1) link = window.location.href;
  // // 组装scheme跳转地址
  // let scheme = `${weMeet.extralLink}?url=${encodeURIComponent(url)}`;
  // if (isSmallWindow(link) && isPC(window.navigator.userAgent)) {
  //   scheme += '&wnd_size_type=1';
  // }
  // onClickJoinForDetail({
  //   http: { post, get },
  //   customScheme: scheme,
  //   countryCode: 'cn',
  //   initLaunchRes: null,
  //   beaconReport: () => { },
  //   wx: window.WeixinJSBridge,
  //   aegis: window.nextAegis,
  //   wxLaunchFailedCallback: () => {
  //     window?.nextAegis?.infoAll(`【wxLaunchFailedCallback open page】 error`);
  //     window.location.href = `${window.location.origin}/download-center.html`;
  //   },
  //   uninstallCb: () => {
  //     window?.nextAegis?.infoAll(`【wxLaunchFailedCallback uninstallCb】 error`);
  //     window.location.href = `${window.location.origin}/download-center.html`;
  //   },
  //   queryLaunchTimeout: {
  //     timeoutCount: 3,
  //     timeoutCallback: () => {
  //       window?.nextAegis?.infoAll(`【wxLaunchFailedCallback timeoutCallback】 error`);
  //       window.location.href = `${window.location.origin}/download-center.html`;
  //     },
  //   },
  // });
};
interface ShareOptParams {
  title?: string;
  desc?: string;
  imageUrl?: string;
  shareUrl?: string;
}
/** 调用app分享方法 */
export const openShareMobileModal = async (shareOpt: ShareOptParams) => {
  const { title = '', desc = '', imageUrl = '', shareUrl = '' } = shareOpt;
  const { app, ui } = await getWeMeet();
  const iswemeet = app.isTMWebview();
  const support = (await app.compare('2.3.0')) > -1;
  window.nextAegis?.infoAll(`【openShareMobileModal】iswemeet,${iswemeet},support,${support}`);
  if (iswemeet) {
    // 当前在wemeet app
    if (!support) {
      message.error({ content: `客户端版本低，请先升级版本再尝试(${DISABLED_TICKET_CODE - 2})` });
      return;
    }
    window.nextAegis?.infoAll(`【openShareMobileModal】iswemeet,${iswemeet},support,${support},
    channels:${wemeet.ExternalShareChannel.QQ},
    ${wemeet.ExternalShareChannel.WECHAT},
      ${wemeet.ExternalShareChannel.WEWORK},
      ${wemeet.ExternalShareChannel.WECHAT_TIMELINE}`);
    ui.openShareBoard({
      channels: [
        wemeet.ExternalShareChannel.WECHAT,
        wemeet.ExternalShareChannel.WEWORK,
        wemeet.ExternalShareChannel.WECHAT_TIMELINE,
        wemeet.ExternalShareChannel.QQ,
      ],
      type: 1,
      title,
      desc,
      imageUrl,
      shareUrl,
      onShared: (resp) => {
        console.log(resp); // { code: number, data: { channel: number }, message: string }
      },
    });
  }
};
